import React from 'react';

interface MarginsEmptyProps {
  height?: number | string;
  width?: number | string;
}

const MarginsEmpty: React.FC<MarginsEmptyProps> = ({ height = undefined, width = 22 }) => {
  return (
    <svg width={height} height={width} viewBox="0 0 214 214" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_3254_25072)">
        <mask
          id="mask0_3254_25072"
          style={{ maskType: 'alpha' }}
          maskUnits="userSpaceOnUse"
          x="27"
          y="54"
          width="160"
          height="160"
        >
          <path
            d="M186.71 134C186.71 178.183 150.958 214 106.855 214C62.7516 214 27 178.183 27 134C27 89.8167 62.7516 54 106.855 54C150.958 54 186.71 89.8167 186.71 134Z"
            fill="white"
          />
        </mask>
        <g mask="url(#mask0_3254_25072)">
          <path
            d="M186.71 134C186.71 178.183 150.958 214 106.855 214C62.7516 214 27 178.183 27 134C27 89.8167 62.7516 54 106.855 54C150.958 54 186.71 89.8167 186.71 134Z"
            fill="#F2F2F2"
          />
          <path d="M181.719 176H27V227H181.719V176Z" fill="#E6E6E6" />
        </g>
        <g filter="url(#filter0_d_3254_25072)">
          <path
            d="M63.6211 76.2476H152.307C152.865 76.2476 153.319 76.6953 153.319 77.2476V187.629C153.319 188.181 152.865 188.629 152.307 188.629H63.6211C63.0622 188.629 62.6091 188.181 62.6091 187.629V77.2476C62.6091 76.6953 63.0622 76.2476 63.6211 76.2476Z"
            fill="black"
          />
        </g>
        <path
          d="M63.6211 76.2476H152.307C152.865 76.2476 153.319 76.6953 153.319 77.2476V187.629C153.319 188.181 152.865 188.629 152.307 188.629H63.6211C63.0622 188.629 62.6091 188.181 62.6091 187.629V77.2476C62.6091 76.6953 63.0622 76.2476 63.6211 76.2476Z"
          fill="white"
          stroke="#504E4E"
          strokeWidth="3"
        />
        <path
          d="M142.102 74H128.251C127.625 74 127.118 74.5014 127.118 75.12V93.3562C127.118 93.9747 127.625 94.4762 128.251 94.4762H142.102C142.728 94.4762 143.236 93.9747 143.236 93.3562V75.12C143.236 74.5014 142.728 74 142.102 74Z"
          fill="#62B5E5"
          stroke="#53565A"
          strokeWidth="2"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M128.826 74.1558C127.198 74.1558 126.62 76.7428 128.826 76.7428C131.033 76.7428 138.153 75.4792 139.715 76.7428C141.277 78.0063 140.754 80.5378 142.109 80.5378C143.465 80.5378 144.291 77.0122 142.712 75.2076C141.133 73.4029 130.454 74.1558 128.826 74.1558Z"
          fill="white"
        />
        <path
          d="M142.102 74H128.251C127.625 74 127.118 74.5014 127.118 75.12V93.3562C127.118 93.9747 127.625 94.4762 128.251 94.4762H142.102C142.728 94.4762 143.236 93.9747 143.236 93.3562V75.12C143.236 74.5014 142.728 74 142.102 74Z"
          stroke="#53565A"
          strokeWidth="2"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M107.954 133.428C112.877 133.428 114.099 127.943 113.488 127.943C112.877 127.943 111.998 132.617 107.954 132.617C103.91 132.617 102.971 127.943 102.42 127.943C101.869 127.943 103.031 133.428 107.954 133.428Z"
          fill="#504E4E"
          stroke="#504E4E"
          strokeWidth="1.12"
        />
        <path
          d="M93.2236 118.952C95.1022 118.952 96.6252 117.443 96.6252 115.581C96.6252 113.719 95.1022 112.209 93.2236 112.209C91.3449 112.209 89.8219 113.719 89.8219 115.581C89.8219 117.443 91.3449 118.952 93.2236 118.952Z"
          fill="#504E4E"
        />
        <path
          d="M122.704 118.952C124.583 118.952 126.106 117.443 126.106 115.581C126.106 113.719 124.583 112.209 122.704 112.209C120.826 112.209 119.303 113.719 119.303 115.581C119.303 117.443 120.826 118.952 122.704 118.952Z"
          fill="#504E4E"
        />
      </g>
      <g clipPath="url(#clip1_3254_25072)">
        <path
          d="M47 44C50.866 44 54 40.866 54 37C54 33.134 50.866 30 47 30C43.134 30 40 33.134 40 37C40 40.866 43.134 44 47 44Z"
          stroke="#F0F0F0"
          strokeWidth="2"
        />
        <path
          d="M138 38C141.866 38 145 34.866 145 31C145 27.134 141.866 24 138 24C134.134 24 131 27.134 131 31C131 34.866 134.134 38 138 38Z"
          stroke="#F0F0F0"
          strokeWidth="2"
        />
        <path
          d="M84 18C86.2091 18 88 16.2091 88 14C88 11.7909 86.2091 10 84 10C81.7909 10 80 11.7909 80 14C80 16.2091 81.7909 18 84 18Z"
          stroke="#F0F0F0"
          strokeWidth="2"
        />
        <path
          d="M122 4C123.105 4 124 3.10457 124 2C124 0.89543 123.105 0 122 0C120.895 0 120 0.89543 120 2C120 3.10457 120.895 4 122 4Z"
          stroke="#F0F0F0"
          strokeWidth="2"
        />
        <path
          d="M32 14C33.1046 14 34 13.1046 34 12C34 10.8954 33.1046 10 32 10C30.8954 10 30 10.8954 30 12C30 13.1046 30.8954 14 32 14Z"
          stroke="#F0F0F0"
          strokeWidth="2"
        />
        <path
          d="M212 44C213.105 44 214 43.1046 214 42C214 40.8954 213.105 40 212 40C210.895 40 210 40.8954 210 42C210 43.1046 210.895 44 212 44Z"
          stroke="#F0F0F0"
          strokeWidth="2"
        />
        <path
          d="M174 28C176.209 28 178 26.2091 178 24C178 21.7909 176.209 20 174 20C171.791 20 170 21.7909 170 24C170 26.2091 171.791 28 174 28Z"
          stroke="#F0F0F0"
          strokeWidth="2"
        />
        <path
          d="M184 68C186.209 68 188 66.2091 188 64C188 61.7909 186.209 60 184 60C181.791 60 180 61.7909 180 64C180 66.2091 181.791 68 184 68Z"
          stroke="#F0F0F0"
          strokeWidth="2"
        />
        <path
          d="M4 58C6.20914 58 8 56.2091 8 54C8 51.7909 6.20914 50 4 50C1.79086 50 0 51.7909 0 54C0 56.2091 1.79086 58 4 58Z"
          stroke="#F0F0F0"
          strokeWidth="2"
        />
      </g>
      <defs>
        <filter
          id="filter0_d_3254_25072"
          x="46.6091"
          y="62.2476"
          width="122.71"
          height="144.381"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="2" />
          <feGaussianBlur stdDeviation="8" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_3254_25072" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_3254_25072" result="shape" />
        </filter>
        <clipPath id="clip0_3254_25072">
          <rect width="160" height="160" fill="white" transform="translate(27 54)" />
        </clipPath>
        <clipPath id="clip1_3254_25072">
          <rect width="214" height="68.8505" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default MarginsEmpty;
